export const LOAN_TYPE = {
  shoppingx3: 'shoppingx3',
  backInTime: 'backInTime',
  magicx3: 'magicx3',
  django_free: 'django_free',
};
